module.exports = __webpack_public_path__ + "img/map-hours-table-nissan.62469046.png";